// @ts-nocheck
import React, { FC, createRef, forwardRef, useContext } from "react";
import "../../../assets/css/colors.css";
import "../../../assets/css/size.css";
import "../../../assets/css/string.css";
import { createUseStyles } from "react-jss";
import { GridHeaderColumnsType, TableComponentProps } from "../../interface";
import { ColumnDirective, GridComponent, ColumnsDirective, GridModel } from "@syncfusion/ej2-react-grids";
import { THEME_DARK, THEME_LIGHT } from "../../../App.constant";
import { ThemeContext } from "../../../ProviderApp";

const useStyles = createUseStyles({
  tableGrid: (props) => ({
    border: props.borderColor,
    "& .e-headercontent": {
      borderRightWidth: "0px !important",
      "& .e-columnheader": {
        "& .e-headercell": {
          background: props.background,
          borderBottom: props.borderColor,
          paddingInlineStart: "22px",
        },
      },
    },
    "& .e-content": {
      overflow: "hidden !important",
    },
    "& .e-gridheader": {
      border: "none !important",
    },
    "& .e-headercelldiv": {
      color: props.colorText,
      fontSize: "14px",
      fontWeight: "600",
    },
    "& .e-rowcell": {
      fontSize: "12px",
      borderColor: "#ecf3fe",
      paddingInlineStart: "23px !important",
      background: props.background,
      color: props.colorText,
    },
    "& .e-grid": {
      border: "none !important",
    },
  }),
});

const TableComponent: FC<TableComponentProps & GridModel> = forwardRef(
  ({ headerColumns, ...rest }: TableComponentProps & GridModel, ref) => {
    /******************* 
@Purpose : table Component
@Parameter : TableComponentProps
@Author : Techture
 *******************/

    const themeContext = useContext(ThemeContext);

    const getBackgroundStyles = () => {
      if (themeContext.themeType == THEME_LIGHT) {
        return "var(--surface-white) !important";
      } else if (themeContext.themeType == THEME_DARK) {
        return "var(--surface-black) !important";
      }
    };

    const getTextColorStyles = () => {
      if (themeContext.themeType == THEME_LIGHT) {
        return "var(--primary-text) !important";
      } else if (themeContext.themeType == THEME_DARK) {
        return "var(--surface-white) !important";
      }
    };

    const getBorderStyle = () => {
      if (themeContext.themeType == THEME_LIGHT) {
        return "1px solid #ecf3fe !important";
      } else if (themeContext.themeType == THEME_DARK) {
        return "white !important";
      }
    };

    const classes = useStyles({
      background: getBackgroundStyles(),
      colorText: getTextColorStyles(),
      borderColor: getBorderStyle(),
    }) as any;

    const gridRef = ref || createRef();

    return (
      <GridComponent {...rest} ref={gridRef} height="30%" className={classes.tableGrid}>
        <ColumnsDirective>
          {headerColumns?.map((s: GridHeaderColumnsType, index: number) => {
            return <ColumnDirective {...s} key={index} />;
          })}
        </ColumnsDirective>
      </GridComponent>
    );
  },
);

TableComponent.defaultProps = {};
TableComponent.displayName = "TableComponent";
export default TableComponent;
